// extracted by mini-css-extract-plugin
export default {"routeSelect":"routeSelect_routeSelect__RXAUP","stopDets":"routeSelect_stopDets__VypYy","selectedRoute":"routeSelect_selectedRoute__f3-0l","altRoutes":"routeSelect_altRoutes__fBMQ-"};